import React, { useContext, useCallback } from "react";
import { Form, Container, Row, Col, Modal } from "react-bootstrap";
import { I18nContext } from "i18n";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import { useUser } from "hooks/useUser";
import Loader from "react-loader-spinner";
import {
  Alert,
  Title,
  Input,
  Button,
  InputPassword,
  Invalid,
  CustomLinks,
} from "components"
import AcceptTermsDialog from './AcceptTermsDialog'
import { useLinks } from 'hooks/useLinks'
import { reactLocalStorage } from 'reactjs-localstorage'

const Login = () => {
  const {
    onSubmit,
    loadingLogin,
    onSubmitForce,
    show,
    setShow,
    message,
    invalid,
    loadingUser,
    loadingDetail,
    showAcceptTerms,
    setShowAcceptTerms,
    onAcceptTerms,
  } = useUser(true);
  const { register, errors, handleSubmit, reset } = useForm();
  const { translate } = useContext(I18nContext);

  reactLocalStorage.remove('snoozeShown')

  const onAcceptTermsCancel = useCallback(() => {
    setShowAcceptTerms()
    reset()
  }, [setShowAcceptTerms])

  return (
    <Container className="my-auto">
      <Row className="justify-content-md-center">
        <Col md={{ offset: 1, span: 5 }} className="border-right">
          <Form onSubmit={handleSubmit(onSubmit)}>
            <fieldset disabled={loadingLogin || loadingUser || loadingDetail}>
              <Title>{translate("login_title")}</Title>
              <Form.Group controlId="username">
                <Input
                  type="text"
                  placeholder={translate("login_username")}
                  name="username"
                  autoFocus={true}
                  ref={register({ required: true })}
                  autoComplete="off"
                  nolabel="true"
                />
                {errors.username && (
                  <Invalid>{translate("login_required")}</Invalid>
                )}
              </Form.Group>
              <Form.Group controlId="password">
                <InputPassword
                  name="password"
                  placeholder={translate("login_password")}
                  register={register({ required: true })}
                  nolabel="true"
                />
                {errors.password && (
                  <Invalid>{translate("login_required")}</Invalid>
                )}
              </Form.Group>

              {invalid && (
                <Alert variant="danger">
                  Incorrect Username or Password. Try again
                </Alert>
              )}
              <Button primary="true" type="submit">
                {loadingLogin || loadingUser || loadingDetail ? (
                  <Loader
                    type="Oval"
                    color="#FFF"
                    height={20}
                    timeout={20000}
                  />
                ) : (
                  translate("login_signin")
                )}
              </Button>
            </fieldset>
          </Form>
        </Col>
        <Col md={5} className="my-auto py-2">
          <p>Sign in using your NSPA member credentials.</p>
          <CustomLinks location="LOGIN.FORGOT_YOUR_PASSWORD" />
          <CustomLinks location="LOGIN.JOIN_TODAY" />
        </Col>
      </Row>
      <ModalContainer
        show={show}
        onHide={() => setShow(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <ModalHeader closeButton>
          <Title>{translate("login_error")}</Title>
        </ModalHeader>
        <Modal.Body>{message}</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            type="button"
            onClick={() => setShow(false)}
          >
            {translate("no")}
          </Button>
          <Button primary="true" onClick={handleSubmit(onSubmitForce)}>
            {translate("yes")}
          </Button>
        </Modal.Footer>
      </ModalContainer>
      <AcceptTermsDialog
        show={showAcceptTerms}
        onHide={onAcceptTermsCancel}
        onConfirm={handleSubmit(onAcceptTerms)}
      />
    </Container>
  );
};

const ModalContainer = styled(Modal)`
  .modal-content {
    border-radius: 0;
    border: 0;
  }
`;

const ModalHeader = styled(Modal.Header)`
  padding: 1rem 1rem 0;
`;

export default Login;
